/* eslint-disable */


/**
 * Create styles for `<OrderQuantity />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<OrderQuantity />` styles
 */
const orderQuantityStyles = ({ theme }) => ({
  progressBar: {
    backgroundColor: theme.palette.grey[200],
    height: theme.spacing(1) * 4.4,
  },
  progressBarText: {
    padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,
    position: `absolute`,
    top: `${theme.spacing(1) * 2}px`,
  },
  quantityContainer: {
    position: `relative`,
  },
});

export default orderQuantityStyles;
